import DOMPurify from "dompurify";

export function sanitizeBody(body: Record<string, unknown>): string {
  const sanitized: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(body)) {
    if (typeof value === "string") {
      sanitized[key] = DOMPurify.sanitize(value);
    } else {
      sanitized[key] = value;
    }
  }

  return JSON.stringify(sanitized);
}
